module.exports = __webpack_public_path__ + "static/05-980b54ff121c893474c55d8c0acb6476.jpg";